import axios, { AxiosResponse } from 'axios';

import { CONFIG } from '@/config/config.ts';

import { HTTP_STATUS } from './ErrorCode.model';
import { HTTP_HEADER } from './httpHeaders.model';
import { maintenanceErrorInterceptor } from './maintenanceInterceptor.util';

const successfulResponseHandler = (response: AxiosResponse): AxiosResponse => {
  if (response.status === HTTP_STATUS.REDIRECT) {
    delete response.headers[HTTP_HEADER['X-CSRF-Token']];
  }

  return response;
};

type Return = ReturnType<typeof axios.create>;

const createAxiosInstance = (): Return => {
  const axiosInstance = axios.create();

  axiosInstance.interceptors.response.use(successfulResponseHandler);
  // Maintenance interceptor MUSI być zarejestrowany jako ostatni:
  // axios wykonuje handlery błędów w odwrotnej kolejności rejestracji,
  // więc ten zadziała jako pierwszy i przerwie łańcuch zanim jakikolwiek
  // inny handler (np. auth/401-redirect) zobaczy odpowiedź 503.
  axiosInstance.interceptors.response.use(res => res, maintenanceErrorInterceptor);

  axiosInstance.interceptors.request.use(
    async config => {
      if (CONFIG.ENVIRONMENT === 'local') {
        config.headers['x-auth-token'] = `${CONFIG.JSESSION}`;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    },
  );

  return axiosInstance;
};

export const sharedAxiosInstance = createAxiosInstance();

export const useAxiosInstance = (): Return => sharedAxiosInstance;
